export const CSAT_FEATURE = 'config.chamadas.csat';
export const CSAT_REPORT_FEATURE = 'relatorios.csat';

export const CSAT_MESSAGES = {
  listTitle: 'Pesquisas CSAT',
  newTitle: 'Nova pesquisa CSAT',
  editTitle: 'Editar pesquisa CSAT',
  newButton: 'Nova pesquisa',
  refreshButton: 'Atualizar lista',
  saveButton: 'Salvar',
  cancelButton: 'Cancelar',
  editTooltip: 'Editar',
  deleteTooltip: 'Excluir',
  empty: 'Nenhuma pesquisa cadastrada',
  created: 'Pesquisa cadastrada com sucesso.',
  updated: 'Pesquisa atualizada com sucesso.',
  deleted: 'Pesquisa excluída com sucesso.',
  loadFailed: 'Erro ao carregar pesquisas.',
  saveFailed: 'Erro ao salvar pesquisa.',
  deleteFailed: 'Erro ao excluir pesquisa.',
  reloadPending: 'Configuração salva, mas o Asterisk não recarregou. Salve novamente em instantes.',
  scaleTenHint: 'Na escala de 1 a 10 o cliente digita 0 para dar nota 10. Grave a pergunta avisando isso.',
  deleteTitle: 'Excluir pesquisa',
  deleteConfirm: 'Excluir',
  deleteLoading: 'Excluindo...',
  nameLabel: 'Nome',
  slugLabel: 'Identificador',
  scaleLabel: 'Escala',
  questionLabel: 'Áudio da pergunta',
  thanksLabel: 'Áudio de agradecimento',
  attemptsLabel: 'Tentativas',
  timeoutLabel: 'Tempo para digitar (segundos)',
  activeLabel: 'Pesquisa ativa',
  statusLabel: 'Situação',
  actionsLabel: 'Ações',
  noThanks: 'Sem agradecimento',
  chooseAudio: 'Selecione um áudio',
  active: 'Ativa',
  inactive: 'Inativa',
  backToList: 'Voltar para Pesquisas CSAT',
};

export const csatPermissions = (hasFeatureFn) => ({
  canCreate: !!hasFeatureFn(CSAT_FEATURE, 'create'),
  canEdit: !!hasFeatureFn(CSAT_FEATURE, 'edit'),
  canDelete: !!hasFeatureFn(CSAT_FEATURE, 'delete'),
});

export const csatDeleteQuestion = (name) =>
  `Tem certeza que deseja excluir a pesquisa ${name}? As respostas já registradas são mantidas.`;

export const scaleLabel = (scale) => (Number(scale) === 10 ? '1 a 10' : '1 a 5');

export const audioKey = (audio) => (audio && audio.type && audio.file ? `${audio.type}/${audio.file}` : '');

export const audioFromKey = (key) => {
  if (!key) return null;
  const separator = key.indexOf('/');
  if (separator < 1) return null;
  return { type: key.slice(0, separator), file: key.slice(separator + 1) };
};

export const emptyCsatForm = () => ({
  name: '',
  slug: '',
  scale: 5,
  questionAudio: '',
  thanksAudio: '',
  maxAttempts: 2,
  inputTimeoutSeconds: 5,
  active: true,
});

export const formFromSurvey = (survey) => ({
  name: survey.name || '',
  slug: (survey.contextName || '').replace(/^csat-/, '').replace(new RegExp(`-${survey.tenant}$`), ''),
  scale: Number(survey.scale) || 5,
  questionAudio: audioKey({ type: survey.questionAudioType, file: survey.questionAudioFile }),
  thanksAudio: audioKey({ type: survey.thanksAudioType, file: survey.thanksAudioFile }),
  maxAttempts: Number(survey.maxAttempts) || 2,
  inputTimeoutSeconds: Number(survey.inputTimeoutSeconds) || 5,
  active: survey.active !== false,
});

export const buildCsatPayload = (values, tenant, mode) => {
  const payload = {
    tenant,
    name: String(values.name || '').trim(),
    scale: Number(values.scale),
    questionAudio: audioFromKey(values.questionAudio),
    thanksAudio: audioFromKey(values.thanksAudio),
    maxAttempts: Number(values.maxAttempts),
    inputTimeoutSeconds: Number(values.inputTimeoutSeconds),
    active: !!values.active,
  };
  if (mode === 'create') payload.slug = String(values.slug || '').trim();
  return payload;
};

export const resultErrorMessage = (result, fallback) => (result && result.error) || fallback;

export const STATUS_LABELS = { answered: 'Respondida', no_response: 'Sem resposta', hung_up: 'Desligou' };

export const statusLabel = (status) => STATUS_LABELS[status] || status;

export const scoreLabel = (score) => (score === null || score === undefined ? '—' : String(score));

const pad = (value) => String(value).padStart(2, '0');

const isoDay = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const lastSevenDays = (now = new Date()) => {
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 6);
  return { from: isoDay(start), to: isoDay(now) };
};

export const percentLabel = (value) => (value === null || value === undefined ? '—' : `${String(value).replace('.', ',')}%`);

export const averageLabel = (value) => (value === null || value === undefined ? '—' : String(value).replace('.', ','));
